export const defaultAxiosInterceptor = (config: any) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem("session_guid")}`;
  return config;
}
